import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateRegulatoryDocumentParagraphsMutationVariables = Types.Exact<{
  input: Types.UpdateRegulatoryDocumentParagraphsInput;
}>;


export type UpdateRegulatoryDocumentParagraphsMutation = { __typename?: 'Mutation', updateRegulatoryDocumentParagraphs: { __typename?: 'UpdateRegulatoryDocumentParagraphsPayload', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string } | null } };


export const UpdateRegulatoryDocumentParagraphsDocument = gql`
    mutation UpdateRegulatoryDocumentParagraphs($input: UpdateRegulatoryDocumentParagraphsInput!) {
  updateRegulatoryDocumentParagraphs(input: $input) {
    regulatoryDocument {
      id
    }
  }
}
    `;
export type UpdateRegulatoryDocumentParagraphsMutationFn = Apollo.MutationFunction<UpdateRegulatoryDocumentParagraphsMutation, UpdateRegulatoryDocumentParagraphsMutationVariables>;

/**
 * __useUpdateRegulatoryDocumentParagraphsMutation__
 *
 * To run a mutation, you first call `useUpdateRegulatoryDocumentParagraphsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegulatoryDocumentParagraphsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegulatoryDocumentParagraphsMutation, { data, loading, error }] = useUpdateRegulatoryDocumentParagraphsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegulatoryDocumentParagraphsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegulatoryDocumentParagraphsMutation, UpdateRegulatoryDocumentParagraphsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegulatoryDocumentParagraphsMutation, UpdateRegulatoryDocumentParagraphsMutationVariables>(UpdateRegulatoryDocumentParagraphsDocument, options);
      }
export type UpdateRegulatoryDocumentParagraphsMutationHookResult = ReturnType<typeof useUpdateRegulatoryDocumentParagraphsMutation>;
export type UpdateRegulatoryDocumentParagraphsMutationResult = Apollo.MutationResult<UpdateRegulatoryDocumentParagraphsMutation>;
export type UpdateRegulatoryDocumentParagraphsMutationOptions = Apollo.BaseMutationOptions<UpdateRegulatoryDocumentParagraphsMutation, UpdateRegulatoryDocumentParagraphsMutationVariables>;